const styles = {
  login_stack: {
    pl: "10%",
    pr: "10%",
    pb: {
      xs: '50px',
      sm: '50px',
      md: '50px',
      lg: '30px',
      xl: '30px',
    },
    margin: '0 auto',
    borderRadius: "16px",
    pt: {
      xs: '40px',
      sm: '40px',
      md: '50px',
      lg: '60px',
      xl: '60px',
    },
    width: {
      xs: '98%',
      sm: '98%',
      md: '98%',
      lg: '90%',
      xl: '90%',
    },
  },
  t_signin: { 
    fontSize: {
      xs: 20,
      sm: 20,
      md: 20,
      lg: 24,
      xl: 24,
    },
    textAlign: "center",
    fontFamily: "Inter",
    color: 'white' 
  },
  t_description: {  
    fontSize: {
      xs: 13,
      sm: 13,
      md: 13,
      lg: 14,
      xl: 14,
    }, 
    textAlign: "center",
    fontFamily: "Inter",
    fontWeight: "700", 
    color: 'white' 
  },
  link: { textDecoration: 'none', color: 'white', alignSelf: "center", paddingTop: 10 },

}

export default styles;